import { TFunction } from "i18next";

export type ErrorCodesType = {
  [key: string]: { translation: (t: TFunction) => string };
};

export const generalErrorCodes = {
  PARAMETER_IS_REQUIRED: {
    code: "PARAMETER_IS_REQUIRED",
    translation: (t: TFunction) => t("Parameter is required"),
  },
  PARAMETER_CANNOT_BE_NULL: {
    code: "PARAMETER_CANNOT_BE_NULL",
    translation: (t: TFunction) => t("Parameter cannot be empty"),
  },
  INVALID_PARAMETER_TYPE: {
    code: "INVALID_PARAMETER_TYPE",
    translation: (t: TFunction) => t("Incorrect parameter type"),
  },
  INVALID_PARAMETER_FORMAT: {
    code: "INVALID_PARAMETER_FORMAT",
    translation: (t: TFunction) => t("Invalid format"),
  },
  INVALID_EMAIL_ADDRESS: {
    code: "INVALID_EMAIL_ADDRESS",
    translation: (t: TFunction) => t("Not a valid email address"),
  },
  PARAMETER_NOT_ENUM: {
    code: "PARAMETER_NOT_ENUM",
    translation: (t: TFunction) => t("Unexpected value"),
  },
  PARAMETER_EXCEEDS_MAX_LENGTH: {
    code: "PARAMETER_EXCEEDS_MAX_LENGTH",
    translation: (t: TFunction) => t("Too long"),
  },
  PARAMETER_NOT_REACH_MINIMUM_LENGTH: {
    code: "PARAMETER_NOT_REACH_MINIMUM_LENGTH",
    translation: (t: TFunction) => t("Too short"),
  },
  PARAMETER_NOT_REACH_MINIMUM: {
    code: "PARAMETER_NOT_REACH_MINIMUM",
    translation: (t: TFunction) => t("Value is too low"),
  },
  PARAMETER_NOT_MATCH_PATTERN: {
    code: "PARAMETER_NOT_MATCH_PATTERN",
    translation: (t: TFunction) => t("Contains invalid characters"),
  },
  PARAMETER_HAVE_INVALID_PROPERTIES: {
    code: "PARAMETER_HAVE_INVALID_PROPERTIES",
    translation: (t: TFunction) => t("Invalid properties"),
  },
  BODY_NOT_MATCH_SCHEMA: {
    code: "BODY_NOT_MATCH_SCHEMA",
    translation: (t: TFunction) => t("Not matching schema"),
  },
  MALFORMED_JSON: {
    code: "MALFORMED_JSON",
    translation: (t: TFunction) => t("An error occurred"),
  },
};
